import { createAction, props } from '@ngrx/store';

const TAG = '[Category/View]';

export const loadCategories = createAction(`${TAG} Load categories`);
export const loadCategory = createAction(
  `${TAG} Load category`,
  props<{ id: number }>()
);
